<template>
  <el-drawer
    :visible.sync="visible"
    direction="rtl"
    size="50%"
    :with-header="false"
    :wrapperClosable="false"
    custom-class="inbound-exception-drawer"
  >
    <div class="form-title">
      <h2>{{ title }}</h2>
      <button class="link" type="button" @click="close">×</button>
    </div>
    <div class="reply-body">
      <p class="reply-desc">异常说明：{{ record.exceptionDesc || "-" }}</p>
      <el-form ref="form" :model="form" :rules="rules" class="reply-form">
        <el-form-item prop="replyResult">
          <span slot="label" class="reply-label">
            回复结果 <b>*</b>
          </span>
          <el-input
            type="textarea"
            v-model="form.replyResult"
            :rows="4"
            placeholder="请直接填写处理结果或备注"
            maxlength="1000"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="form-foot">
      <el-button @click="close">取消</el-button>
      <el-button type="success" :loading="saving" @click="submit">{{ submitText }}</el-button>
    </div>
  </el-drawer>
</template>

<script>
import { inboundExceptionReply } from "@/apis/inHouse";
import { EXCEPTION_STATUS } from "../data";

export default {
  name: "ReplyDrawer",
  computed: {
    // 是否已回复
    alreadyReplied: function () {
      return Number(this.record.status) === EXCEPTION_STATUS.REPLIED;
    },
    // 抽屉标题
    title: function () {
      return this.alreadyReplied ? "修改采购回复" : "填写采购回复";
    },
    // 提交按钮文案
    submitText: function () {
      return this.alreadyReplied ? "更新回复" : "提交回复";
    },
  },
  data() {
    return {
      // 抽屉显示
      visible: false,
      // 提交中
      saving: false,
      // 当前异常
      record: {},
      // 回复表单
      form: {
        replyResult: "",
      },
      // 校验
      rules: {
        replyResult: [{ required: true, message: "请填写回复结果", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 打开回复抽屉
    open: function (record) {
      this.record = record || {};
      this.form.replyResult = this.record.replyResult || "";
      this.visible = true;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    // 关闭抽屉
    close: function () {
      this.visible = false;
    },
    // 提交回复
    submit: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.saving = true;
        inboundExceptionReply({
          exceptionCode: this.record.exceptionCode,
          replyResult: this.form.replyResult,
        })
          .then((res) => {
            if (res.code === 0) {
              this.$message.success("回复结果已保存");
              this.close();
              this.$emit("confirm");
            }
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.form-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e2e7ea;
  padding: 18px 24px 14px;
  flex-shrink: 0;
  text-align: left;
}

.form-title h2 {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #27313b;
}

.link {
  border: 0;
  background: none;
  font-size: 24px;
  line-height: 1;
  color: #71808a;
  cursor: pointer;
  padding: 0 4px;
}

.reply-body {
  padding: 18px 24px 24px;
  overflow: auto;
  flex: 1;
  text-align: left;
}

.reply-desc {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 22px;
  color: #27313b;
  text-align: left;
  word-break: break-word;
}

.reply-label {
  color: #56636c;
  font-weight: normal;
}

.reply-label b {
  color: #d24d4d;
  font-weight: normal;
  margin-left: 2px;
}

.reply-form >>> .el-form-item {
  margin-bottom: 0;
}

.reply-form >>> .el-form-item__label {
  float: none;
  display: block;
  width: auto !important;
  text-align: left !important;
  padding: 0 0 6px;
  line-height: 1.4;
}

.reply-form >>> .el-form-item__content {
  margin-left: 0 !important;
  line-height: normal;
  text-align: left;
}

.reply-form >>> .el-textarea__inner {
  height: 92px;
  min-height: 92px;
  padding: 9px;
  line-height: 22px;
  text-align: left;
}

.form-foot {
  flex-shrink: 0;
  border-top: 1px solid #e2e7ea;
  padding: 14px 24px;
  text-align: right;
  background: #fff;
}
</style>
